import { ReactNode } from 'react';
import { H1, H2, H2Medium, H3, H3Medium, H4, H4Medium, Headline } from './heading.styles';
export enum Level {
    headline = 0,
    h1 = 1,
    h2 = 2,
    h2Medium = 3,
    h3 = 4,
    h3Medium = 5,
    h4 = 6,
    h4Medium = 7,
}
export interface HeadingProps {
    children: ReactNode;
    level: Level;
    color?: string;
    tid?: string;
    textAlign?: string;
    ellipsis?: boolean;
    /**
     * Let the heading break at any character, so that one long unbroken name can't hold its
     * container wider than the screen. Leave it off for prose: squeezed, it breaks ordinary words
     * too.
     */
    breakAnywhere?: boolean;
}
export function Heading({
    children,
    level,
    color,
    tid,
    textAlign,
    ellipsis,
    breakAnywhere = false,
}: HeadingProps) {
    let ComponentType: any = H1;
    switch (level) {
        case Level.headline:
            ComponentType = Headline;
            break;
        case Level.h4:
            ComponentType = H4;
            break;
        case Level.h4Medium:
            ComponentType = H4Medium;
            break;
        case Level.h3:
            ComponentType = H3;
            break;
        case Level.h3Medium:
            ComponentType = H3Medium;
            break;
        case Level.h2:
            ComponentType = H2;
            break;
        case Level.h2Medium:
            ComponentType = H2Medium;
            break;
        case Level.h1:
        default:
            ComponentType = H1;
            break;
    }
    return (
        <ComponentType
            data-test-id={tid}
            color={color}
            $textAlign={textAlign}
            $ellipsis={ellipsis}
            $breakAnywhere={breakAnywhere}
        >
            {children}
        </ComponentType>
    );
}
